export default "__VITE_ASSET__e9af0e6c__"